import * as Yup from "yup";

export const initialValuesAccount = {
    account_name: "",
    account_code: "",
    account_sequence: 1
}

export const validationSchemaAccount = Yup.object().shape({
    "account_name": Yup.string().required('El nombre de la cuenta es requerido.'),
    "account_code": Yup.string().required('El código de la cuenta  es requerido.'),
    "account_sequence": Yup.number().required('La secuencia de la cuenta es requerida.')
})